import useMeowLightboxContext from "../context";
import { useController } from "../helpers";
import { MwlIcons } from "../components/MwlIcons";

export const Navigation = ({ className }) => {
  const { onPrevClick, onNextClick } = useController();
  const { images } = useMeowLightboxContext();

  if (images.length < 2) {
    return null;
  }

  return (
    <div className={className}>
      <div className="mwl__navigation__previous" onClick={onPrevClick}>
        <MwlIcons icon="arrow_left" />
      </div>
      <div className="mwl__navigation__next" onClick={onNextClick}>
        <MwlIcons icon="arrow_right" />
      </div>
    </div>
  );
};
